<div class="spacing">Click Add Faculty to add new faculty to the roster. A prompt will appear to search 
    existing AAOS members before adding a new one. Click the ellipsis menu to the right of each faculty member for a list of
    additional options.
</div>
<div class="spacing">
    <div class="small-bottom-margin">
        <button class="btn btn--right btn--solid btn--red" [disabled]="!editPrivileges"  (click)="openFacultySearchDialog()">Add Faculty Member</button>
    </div>
</div>
<table class="mat-elevation-z8" matSort mat-table matSortActive="lastName" matSortDirection="asc" [dataSource]="dataSource">

    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
      <td mat-cell *matCellDef="let facultyMember"> {{facultyMember.firstName}} </td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
      <td mat-cell *matCellDef="let facultyMember"> {{facultyMember.lastName}} </td>
    </ng-container>

    <ng-container matColumnDef="emailAddress">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let facultyMember"> {{facultyMember.emailAddress}} </td>
    </ng-container>
    <ng-container matColumnDef="dateAdded">
      <th mat-header-cell *matHeaderCellDef> Date Added </th>
      <td mat-cell *matCellDef="let facultyMember"> {{facultyMember.dateAdded | date: 'MMMM d, yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let facultyMember">  
        <div class="faculty-table-horiztonal-ellipsis" [matMenuTriggerFor]="menu"></div>
        <mat-menu #menu="matMenu" yPosition="below" xPosition="after">
          <button mat-menu-item [disabled]="!editPrivileges" (click)="openRemoveFacultyDialog(facultyMember)">Remove</button>
        </mat-menu>
      </td>

    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

  </table>
<aaos-spinner [isLoading]="loading"></aaos-spinner>